import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';
import { MessagingProvider } from '.';
import MessagingService from '../../services/MessagingService';
import { useMember } from '../SessionProvider';
import { useIdentityService } from '../IdentityProvider';
import type { ChatChannelStateType, ChatMessagingStateType } from './models';
import ImageService from '../../services/ImageService';

const ChatMessagingServiceContext = createContext<MessagingService>(
  {} as MessagingService
);
const ImageServiceContext = createContext<ImageService>({} as ImageService);
const ChatMessagingState = createContext<Partial<ChatMessagingStateType>>({});
const ChatChannelState = createContext<Partial<ChatChannelStateType>>({});

const useLineChatMessagingService = () =>
  useContext(ChatMessagingServiceContext);
const useLineImageService = () => useContext(ImageServiceContext);
const useLineChatMessagingState = () =>
  useContext(ChatMessagingState) as ChatMessagingStateType;
const useLineChatChannelState = () =>
  useContext(ChatChannelState) as ChatChannelStateType;

const LineChatMessagesProvider: FC<
  PropsWithChildren<{
    chimeIdVal?: string;
    loadChannels?: boolean;
  }>
> = ({ children, chimeIdVal, loadChannels }) => {
  const { member } = useMember();
  const [chimeId, setChimeId] = useState<string>();
  const { useCompany } = useIdentityService();
  const { data: company } = useCompany(true);
  // ライン問い合わせ用のchimeidをセットしておく
  useEffect(() => {
    if (chimeIdVal) {
      setChimeId(chimeIdVal);
    } else if (member.companyId) {
      company && setChimeId(company?.noticeChimeId);
    } else {
      setChimeId(member.userId);
    }
  }, [member.companyId, company]);

  return (
    <>
      {chimeId ? (
        <MessagingProvider
          chimeId={chimeId}
          ChatMessagingServiceContext={ChatMessagingServiceContext}
          ImageServiceContext={ImageServiceContext}
          ChatMessagingState={ChatMessagingState}
          ChatChannelState={ChatChannelState}
          loadChannels={loadChannels}
        >
          {children}
        </MessagingProvider>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export {
  LineChatMessagesProvider,
  useLineChatMessagingService,
  useLineImageService,
  useLineChatMessagingState,
  useLineChatChannelState
};
